/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import {
  AddButton,
  Buttons,
  CancelButton,
  DeleteButton,
  UpdateButton,
} from '../../../components/Common/iComponents/iPopUp/IpopUp';

import { useSelector, useDispatch } from 'react-redux';

import {
  getEntitiesList,
  getEntity,
  getEntityReset,
} from '../../../store/Entities/actions';

import { IInput } from '../../../components/Common/iComponents/iInput/iInput';
import { ISelector } from '../../../components/Common/iComponents/iSelector/iSelector';
import { Button, FormGroup, Input, Label } from 'reactstrap';
import Select from 'react-select';

import { getLocationShopify } from '../../../store/apiList/actions';
import { extractIdAndCleanText, changeNameLocation } from '../../../helpers/tools_helper';

const FormSubApis = ({
  selectedRow,
  onCreate,
  onUpdate,
  onDelete,
  onCancel,
  clientId,
  identificator,
}: any) => {

  let arrayUpdAdd = ['entityId', 'host', 'token', 'location'];
  if (identificator === "CIN7") arrayUpdAdd = ['entityId', 'host', 'token Account Id', 'token Application Key', 'location'];
  if (identificator === "SHOPIFY") arrayUpdAdd = ['entityId', 'host', 'token', 'location Shopify'];

  const [form, setForm] = useState<any>({ entityId: '', host: '', token: '', location: '', 'token Account Id': '', 'token Application Key': '', 'location Shopify': undefined });
  const [flag, setflag] = useState<any>(true);

  const dispatch = useDispatch();
  const valuesSizeEntitiesPagination = [20, 40, 60, 80, 100, 200];
  const [paginationEntities, setPaginationEntities] = useState<any>({
    sizePerPage: valuesSizeEntitiesPagination[0],
    page: 1,
  });

  const [modalEntity, setModalEntity] = useState<any>(false);
  const [queryEntity, setQueryEntity] = useState<any>('');

  const { testApi: testApiIcon } = useSelector((state: any) => state.ApiList);
  const { locations, isLoading: isLoadingLocations, message } = useSelector((state: any) => state.ApiList);
  const [dataLocations, setDataLocation] = useState<any>([]);
  const [messageLocation, setMessageLocation] = useState<any>("");
  const { EntitiesList, lengthEntities, currentEntity, isLoading } =
    useSelector((state: any) => state.Entities);

  const initialArrayTableEntities = [
    {
      text: 'Id',
      dataField: 'id',
      formatter: (cellContent: any, clients: any) => <>{clients.id}</>,
      hidden: false,
    },
    {
      text: 'Name',
      dataField: 'name',
      formatter: (cellContent: any, clients: any) => <>{clients.name}</>,
      hidden: false,
    },
  ];

  useEffect(() => {
    if (!modalEntity) {
      setPaginationEntities({
        sizePerPage: valuesSizeEntitiesPagination[0],
        page: 1,
      });
    }
  }, [modalEntity]);

  useEffect(() => {
    let entityName = false;

    if (queryEntity.length > 3 || queryEntity === '') {
      entityName = true;
    }

    if (entityName) {
      dispatch(
        getEntitiesList({
          pagination: paginationEntities,
          form: { dynamicFilter: `,name: "${queryEntity}"` },
          clientId,
        }),
      );
    }
  }, [queryEntity, paginationEntities]);

  useEffect(() => {
    dispatch(getEntitiesList({ pagination: paginationEntities, clientId }));
    dispatch(getEntityReset());
  }, []);

  useEffect(() => {
    if (message === "Success") {
      let newArray = [...locations];
      newArray = newArray.map((val: any) => {
        val.active = val.active ? 'Active' : 'Inactive';
        const label = [
          val.name,
          val.country_name,
          val.address1,
          val.province,
          val.address1,
          val.active
        ]
          .filter(Boolean)
          .join("@@@");
        const value = label + "@@@" + val.id;
        return {
          label: changeNameLocation(label),
          value
        }
      });

      newArray.unshift({ label: 'All Locations', value: 'All Locations' });
      setDataLocation(newArray);
    }
    setMessageLocation(message);
  }, [locations, messageLocation]);
  useEffect(() => {
    const { entityId, host, token } = form;

    if (entityId != '' && host != '') {
      setflag(false);
    } else {
      setflag(true);
    }
  }, [form, testApiIcon]);

  useEffect(() => {
    if (form['entityId']) dispatch(getEntity({ entityId: form['entityId'] }));
  }, [form['entityId']]);

  useEffect(() => {
    setForm({
      ...form,
      tokenAccountId: form['token Account Id'] ?? "",
      tokenApplicationKey: form['token Application Key'] ?? ""
    })
  }, [form['token Account Id'], form['token Application Key']]);

  useEffect(() => {
    setDataLocation([]);
    setMessageLocation("");
    if (selectedRow) {
      setForm({
        ...selectedRow,
        ['token Account Id']: selectedRow.tokenAccountId ?? '',
        ['token Application Key']: selectedRow.tokenApplicationKey ?? ''
      });
    }
  }, [selectedRow]);

  const handlePaginationEntitiesChange = (newState: any) => {
    setPaginationEntities(newState);
  };

  const renderButtons = () => (
    <Buttons style={{ background: selectedRow ? 'white' : '' }}>
      <CancelButton
        className={` ${!selectedRow ? 'm-2' : ''} button`}
        onClick={() => onCancel()}
        data-bs-toggle="tooltip"
      >
        <i
          className="bx bx-x"
          style={{ fontSize: '2.5em' }}
          data-bs-toggle="tooltip"
        ></i>
      </CancelButton>
      {selectedRow ? (
        <>
          <DeleteButton
            type="button"
            className="btn-delete button"
            onClick={() => onDelete(selectedRow)}
          >
            <i className="dripicons-trash" style={{ fontSize: '1.7em' }}></i>
          </DeleteButton>
          <UpdateButton
            className="button"
            onClick={() => onUpdate({ ...form, iEntity: currentEntity })}
          >
            <i className="bx bx-sync" style={{ fontSize: '2.5em' }}></i>
          </UpdateButton>
        </>
      ) : (
        <AddButton
          type="submit"
          disabled={flag}
          className="btn"
          onClick={() => {
            onCreate({ ...form, iEntity: currentEntity });
          }}
        >
          <i className="bx bx-plus" style={{ fontSize: '3em' }} />
        </AddButton>
      )}
    </Buttons>
  );

  const onChangeHandler = (e: any, n: any) => {
    setForm({
      ...form,
      [n]: e.target.value,
    });
  };
  const onChangeSelectorHandler = (n: any, value: any) => {
    setForm({
      ...form,
      [n]: String(value.id),
    });
  };

  return (
    <div style={{ width: '100%', height: '550px' }}>
      <div
        className="row pt-5 pe-5 ps-5"
        style={{
          paddingTop: '0.5%',
        }}
      >
        {arrayUpdAdd?.map((val: any) => {
          const nameObject = val as keyof typeof form;
          let temp = form[nameObject];
          const valid = temp ? true : false;
          let type = '';
          let nameSelector = '';

          switch (val) {
            case 'entityId':
              nameSelector = currentEntity?.name ?? '';
              return (
                <div className="col-12 pb-2 ">
                  <ISelector
                    isLoading={isLoading}
                    getQuery={setQueryEntity}
                    queryRemote={true}
                    getModalStatus={setModalEntity}
                    titleSearch="Entity Name"
                    remote={true}
                    title={val}
                    value={String(temp)}
                    nameSelector={nameSelector ?? ''}
                    valuesSizePagination={valuesSizeEntitiesPagination}
                    dataSelector={EntitiesList}
                    CountItems={lengthEntities}
                    initialArrayTable={initialArrayTableEntities}
                    handlePaginationChange={handlePaginationEntitiesChange}
                    setSelectedRow={onChangeSelectorHandler}
                    onChangeHandler={onChangeHandler}
                  />
                </div>
              );
            case 'location Shopify':
              temp = form.location;
              nameSelector = currentEntity?.name ?? '';
              return (
                <div className="col-12 row pb-2">
                  <div className="text-capitalize text-center">
                    <Label>location</Label>
                  </div>
                  <div className="col-11">
                    {dataLocations.length === 0 ?
                      <Input
                        readOnly
                        title="Click the button on the right to select a new location."
                        value={changeNameLocation(
                          extractIdAndCleanText(temp)) ?? "Click the button on the right to select a location."}
                      />
                      :
                      <FormGroup>
                        <Select
                          styles={{
                            menu: (provided: any) => ({ ...provided, maxHeight: '150px', zIndex: 99, }),
                            menuList: (provided: any) => ({ ...provided, maxHeight: '150px', fontSize: 12 }),
                          }}
                          defaultValue={{
                            label: changeNameLocation(
                              extractIdAndCleanText(temp) ?? "Select a location"), value: temp
                          }}
                          onChange={(e: any) => {
                            setForm({ ...form, location: e.value });
                          }}
                          options={dataLocations}
                          classNamePrefix="select2-selection"
                        />
                      </FormGroup>
                    }
                  </div>
                  <div className="col-1">
                    <Button className='pb-1'
                      disabled={form.token === "" || form.host === ""}
                      onClick={() => {
                        dispatch(getLocationShopify({ token: form.token, host: form.host }));
                      }}
                      title="Click the button to select a location."
                    >
                      <i className={isLoadingLocations ? "bx bx-loader-alt bx-spin" : "bx bx-refresh"} style={{ fontSize: '1em' }} />
                    </Button>
                  </div>
                  {message !== "Success" && <div className='d-flex justify-content-center align-self-center'>
                    <Label className="position-absolute pt-2 fs-5 text-danger">{messageLocation}</Label>
                  </div>}
                </div>
              );

            default:
              type = 'text';
              break;
          }
          return (
            <div className="col-12 pb-2">
              <IInput
                title={val}
                valid={valid}
                value={String(temp)}
                type={type}
                onChangeHandler={onChangeHandler}
              />
            </div>
          );
        })}
      </div>
      <div style={{ paddingTop: "150px" }} className="pe-5 d-flex justify-content-end">
        {renderButtons()}
      </div>
    </div>
  );
};

FormSubApis.propTypes = {
  apiId: PropTypes.string,
  selectedRow: PropTypes.object,
  onCreate: PropTypes.func,
  onUpdate: PropTypes.func,
  onCancel: PropTypes.func,
  onDelete: PropTypes.func,
  SubApiCreate: PropTypes.func,
  clientId: PropTypes.string,
  identificator: PropTypes.string,
};

export default FormSubApis;
